// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table th.model-code,\n.el-table td.model-code {\n  width: 9em;\n}", ""]);
// Exports
module.exports = exports;
